import {
  useOrderReturnRequests,
  type UseOrderReturnRequestsParams,
} from "@babackapp/private-api-client/client/use-order-return-requests";
import type { ReturnRequest } from "../types";

export function useReturnRequests(params: UseOrderReturnRequestsParams) {
  return useOrderReturnRequests(params);
}

/**
 * Returns `undefined` when the return request is not in the order's list.
 * The public search endpoint excludes cancelled returns, so a missing id
 * usually means the return was just cancelled (here, from another tab, or by
 * the merchant): callers must handle it instead of crashing.
 */
export function useReturnRequest({
  returnRequestId,
  ...params
}: UseOrderReturnRequestsParams & { returnRequestId: string }) {
  return useOrderReturnRequests<ReturnRequest | undefined>({
    ...params,
    select: (data) =>
      data.returnRequests.find((rr) => rr.id === returnRequestId) as
        | ReturnRequest
        | undefined,
  });
}

export type { UseOrderReturnRequestsParams };
